export default __webpack_public_path__ + "static/media/minor-stops.4b5880bf.svg";